"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isContentCollectionStencil = exports.contentCollectionStencilDefinition = void 0;
const properties_1 = require("../properties");
exports.contentCollectionStencilDefinition = {
    view: {
        label: 'Content Collection',
        group: 'Collections',
        titleItems: ['title'],
        imageItems: ['featured-media'],
        contentAreas: [
            {
                name: 'main',
                items: [
                    'header-media',
                    'title',
                    'subheading',
                    'teaser',
                ],
            },
            {
                name: 'info',
                subAreas: [
                    {
                        name: 'General',
                        items: [
                            'type-of-content-collection',
                            'seo-title',
                            'social-title',
                            'featured-title',
                            'uri-title',
                            'preferred-label',
                            'featured-media',
                            'featured-video',
                            'logos',
                        ],
                    },
                    {
                        name: 'CTA',
                        items: ['cta-container'],
                    },
                    {
                        name: 'Settings',
                        items: ['search-terms', 'standalone'],
                    },
                    {
                        name: 'Custom Properties',
                        items: ['properties-container'],
                    },
                ],
            },
            {
                name: 'tagging',
                subAreas: [
                    {
                        name: 'Configuration',
                        items: ['exclude-content-tagged-with', 'include-content-tagged-with'],
                    },
                    {
                        name: 'Tagging',
                        items: [
                            'disciplines',
                            'content-categories',
                            'tag-events',
                            'tag-event-series',
                            'tag-persons',
                            'tag-teams',
                            'related-content',
                        ],
                    },
                ],
            },
        ],
        previewConfiguration: {
            hasPagePreview: true,
            hasFeatureCardPreview: true,
        },
    },
    content: {
        'content-categories': properties_1.contentCategoriesPropertyDefinition,
        'cta-container': properties_1.ctaContainerPropertyDefinition,
        disciplines: properties_1.disciplinesPropertyDefinition,
        'exclude-content-tagged-with': properties_1.excludeContentTaggedWithPropertyDefinition,
        'featured-media': properties_1.featuredMediaPropertyDefinition,
        'featured-title': properties_1.featuredTitlePropertyDefinition,
        'featured-video': properties_1.featuredVideoPropertyDefinition,
        'header-media': properties_1.headerMediaPropertyDefinition,
        'include-content-tagged-with': properties_1.includeContentTaggedWithPropertyDefinition,
        logos: properties_1.logosPropertyDefinition,
        'preferred-label': properties_1.preferredLabelPropertyDefinition,
        'properties-container': properties_1.propertiesContainerPropertyDefinition,
        'related-content': properties_1.relatedContentPropertyDefinition,
        'search-terms': properties_1.searchTermsPropertyDefinition,
        'seo-title': properties_1.seoTitlePropertyDefinition,
        'social-title': properties_1.socialTitlePropertyDefinition,
        standalone: {
            ...properties_1.standalonePropertyDefinition,
            default: true,
        },
        subheading: {
            ...properties_1.subheadingPropertyDefinition,
            constraints: [
                {
                    name: 'maxLength',
                    argument: 240,
                },
            ],
        },
        'tag-events': properties_1.tagEventsPropertyDefinition,
        'tag-event-series': properties_1.tagEventSeriesPropertyDefinition,
        'tag-persons': properties_1.tagPersonsPropertyDefinition,
        'tag-teams': properties_1.tagTeamsPropertyDefinition,
        title: properties_1.titlePropertyDefinition,
        teaser: properties_1.teaserPropertyDefinition,
        'uri-title': properties_1.uriTitlePropertyDefinition,
        'type-of-content-collection': properties_1.typeOfContentCollectionPropertyDefinition,
    },
    localizations: [],
    roles: ['taxonomy-manager'],
    spaces: [
        'batalla',
        'brand-building-events',
        'cartoons',
        'erc',
        'global',
        'illume',
        'media-partnerships',
        'organics',
        'organics-mixed-consumption',
        'pro-cycling',
        'racing-bulls',
        'rb-juniorteam',
        'rb-rookies',
        'rbtv',
        'rbtv_temporary',
        'redbull-advancedtechnologies',
        'redbull-f1academy',
        'redbull-powertrains',
        'redbull-racing',
        'redbull-simracing',
        'redbull_com',
        'redbulletin',
        'redbullmusic',
        'wingfinder',
        'wrc',
        'xalps',
    ],
    name: 'content-collection',
};
const isContentCollectionStencil = (stencil) => {
    return stencil.name === exports.contentCollectionStencilDefinition.name;
};
exports.isContentCollectionStencil = isContentCollectionStencil;
//# sourceMappingURL=data:application/json;base64,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